"use strict";
// These are common snippets used across scripts.


// Mobile devices trigger a resize event when the browser's navbar disappears & reappears (triggered by scrolling).
// Elements only looking to resize based on the width changing don't need to resize times only the height is changed.
export function onWindowWidthChange(action) {
	var viewWidth = 0;

	window.addEventListener("resize", function() {
		if (viewWidth != window.innerWidth) {
			action();
			viewWidth = window.innerWidth;
		}
	});
}


// Set multiple attributes at a time.
export function setAttributes(el, attrs) {
	for(var key in attrs) {
		el.setAttribute(key, attrs[key]);
	}
}
